import React, { Component } from 'react';
 
import {BlueWalletIcon} from './BlueWalletIcon';
import { BlueCircleIcon } from './BlueCircleIcon';
import Select from 'react-select';
import Cookies from 'universal-cookie';
import axios from 'axios'; 
import { InfoIcon } from './InfoIcon';
import validator from 'validator'


export class Balance extends React.Component {


    state = {
      n_months : 1,
      price : process.env.REACT_APP_TARIF_MONTH,
      email: '',
      amount: 0
    }


    
    customStyles = {
      option: (provided, state) => ({
        ...provided,
        
        color: state.isSelected ? 'red' : 'blue',
        
      }),
      control: () => ({
        // none of react-select's styles are passed to <Control />
        width: 600,
      }),
      singleValue: (provided, state) => {
        const opacity = state.isDisabled ? 0.5 : 1;
        const transition = 'opacity 300ms';
    
        return { ...provided, opacity, transition };
      }
    }


    constructor(props) {
        super(props);
        this.options = [
          { value: '1', label: '1 месяц' },
          { value: '3', label: '3 месяца' },
          { value: '6', label: '6 месяцев' },
          { value: '12', label: '12 месяцев' },
        ];

        const cookies = new Cookies();
        
      }
    
    componentDidMount() {
      const cookies = new Cookies();
      axios.get(process.env.REACT_APP_BACKEND_SERVER + '/GetTarifData', {
                  headers: {
                  'Authorization': 'Bearer ' + cookies.get('tgsubs_token')
                  }
              }).then(res => {
                  //projects = res.data.projects

                      cookies.set('tarif_expiration_date', res.data.tarif_expiration_date, {path : '/'})
                      cookies.set('dop_balance', res.data.dop_balance, {path : '/'})
                      cookies.set('tarif_sub_remains', res.data.tarif_sub_remains, {path : '/'})
                  
                      this.setState( {
                          tarif_expiration_date: res.data.tarif_expiration_date,
                          dop_balance : res.data.dop_balance,
                          tarif_sub_remains : res.data.tarif_sub_remains,
                      });
                 
                  

              })
              .catch(err => {
                  console.log(err);
                  

              })
    }


    handleChangePrice = (e) => {
      var selectedOption = e.target.value
      this.setState((prevState) => {
        return  {
               ...prevState,
               selectedOption : selectedOption,
               n_months : Number(selectedOption),
               price : Number(selectedOption) * Number(process.env.REACT_APP_TARIF_MONTH)
           };
   }, () =>  {
       
   })  
    };

    
    handleChangeEmail = (e) => {
       
      this.setState((prevState) => {
        return  {
               ...prevState,
              email : e.target.value
           };
   }, () =>  {
       
   })  
    };


    changeDopBalance =(e)  =>{
      this.setState((prevState) => {
        return  {
               ...prevState,
               amount : e.target.value
           };
   }, () =>  {
       
   })  
    }

    createAjaxRequest(a) {
      const cookies = new Cookies();
      
     
      if (validator.isEmail(this.state.email)){


        if (a == 'access') {
        
          axios
              .post(process.env.REACT_APP_BACKEND_SERVER+'/CreatePayment/', {
                  
                  'type' : 'access',
                  'n_months' : this.state.n_months,
                  'email' : this.state.email
              }, {
                headers : {
                    'Authorization': 'Bearer '+cookies.get('tgsubs_token')
                }
            })
              .then(res => {
                  if (res.data.status == 'ok') {
                    
                    window.open(res.data.url, '_blank').focus();
                   
                    
                    /*this.setState({
                        
                      }, () => {
  
                      })
                  */
                    }
                  
              })
              .catch(err => {
              console.log(err);
              })
        }
        else {
          
          axios
          .post(process.env.REACT_APP_BACKEND_SERVER+'/CreatePayment/', {
              
              'type' : 'dopBalance',
              'amount' : parseInt(this.state.amount),
              'email' : this.state.email
          }, {
            headers : {
                'Authorization': 'Bearer '+cookies.get('tgsubs_token')
            }
        })
          .then(res => {
              if (res.data.status == 'ok') {
                
                window.open(res.data.url, '_blank').focus();
               
                
                /*this.setState({
                    
                  }, () => {

                  })
              */
                }
              
          })
          .catch(err => {
          console.log(err);
          })

        }
        



      }
      else {
        alert('Email некорректный')
      }
      
      
    }


    


    render() {
        return (
            <div className='createPage'>
                

                <h1> Оплата </h1>
                <svg
                className='h1_line'
      xmlns="http://www.w3.org/2000/svg"
      width="117"
      height="1"
      fill="none"
      viewBox="0 0 117 1"
    >
      <path stroke="url(#paint0_linear_35_988)" d="M0 0.5L117 0.5"></path>
      <defs>
        <linearGradient
          id="paint0_linear_35_988"
          x1="-0.325"
          x2="117.101"
          y1="1"
          y2="1"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0767F4"></stop>
          <stop offset="1" stopColor="#2AC3D1"></stop>
        </linearGradient>
      </defs>
    </svg>
    
    <div className="balancePageAll">
          <div className="balancePageAll_row1">
             <div className='balancePage_infoBlock'>
                <div className='balancePage_infoBlock_name balancePage_infoBlock_icon'> <BlueCircleIcon /> 
                <span className="">Правила тарификации</span> </div>
                <div className='balancePage_infoBlock_text balancePage_infoBlock_textbalancePage_infoBlock_info'>
               <span className="balancePageTextBlockSpan">
               Для того, чтобы пользоваться сервисом надо оплатить доступ на месяц. 
        Доступ предполагает <span className='blue'>1000</span> уникальных подписчиков в месяц. 
        Если у вас меньше <span className='blue'>1000</span> подписчиков, то на следующий месяц остаток сгорает. 
        Если у вас больше <span className='blue'>1000</span> подписчиков в месяц, вы можете пополнить 
        баланс и оплачивать дополнительных подписчиков по цене <span className='blue'>{process.env.REACT_APP_DOP_SUB_PRICE * 100} коп.</span> за подписчика.
        Аналогично, когда у вас закончатся изначальные <span className='blue'>10000</span> сообщений в месяц, с баланса
        будет списываться  <span className='blue'>{process.env.REACT_APP_DOP_MSG_PRICE * 100} коп.</span> за сообщение.</span> 
                </div>
                <div className="balancePage_infoBlock_infoHighlight">
                  <div className="balancePage_infoBlock_infoHighlight_svg balancePage_infoBlock_icon"><InfoIcon /></div>
                  <div className="balancePage_infoBlock_infoHighlight_text">
                    <span className='balancePageTextBlockSpan'>Если по окончанию действия тарифа у вас останутся деньги на балансе, 
        они не сгорают, но тариф на следующий месяц придется покупать отдельно.</span></div>
                </div>
             </div>
          </div>
          <div className='balancePageAll_row2'>
          <div className="balancePage_balanceBlock__exapanded balancePage_balanceBlock balancePage_tarifBlock balancePage_balanceBlockFirst">
        <div className='balancePage_balanceBlock_label'> <BlueWalletIcon /> Тариф </div>
        <div className="balancePage_tarifBlock_status">
          Дата окончания подписки:
          <div className='balancePage_tarifBlock_status_date'>{this.state.tarif_expiration_date}</div> 
          </div>
       
        <div className="balancePage_tarifBlock_activation">
        Активировать на
        {/*  <Select
        styles={this.customStyles}
        option={this.state.selectedOption}
        defaultValue={this.state.selectedOption}
        onChange={this.handleChange}
        options={this.options}/>  */}
        <select className='select-css' value={this.state.value} onChange={this.handleChangePrice}>
            <option value="1">1 месяц</option>
            
            <option value="3">3 месяца</option>
            <option value="6">6 месяцeв</option>
            <option value="12">1 год</option>
          </select>
       
        <div className="balancePage_tarifBlock_showPrice">
          К оплате: <span className="balancePage_tarifBlock_showPrice_label">{this.state.price} руб</span> 
        </div>

        <div style={{'marginTop': '3em'}}>
          Введите email для получения чека: 
          <input onChange={this.handleChangeEmail} value={this.state.email} style={{ 'color' : '#8D8D8D','paddingLeft': '1em', 'marginTop': '0.3em', 'height': '2.3em'}} type='text' />

        </div>

        <div className='balancePage_tarifBlock_buttonBlock' style={{marginTop: '2.3em'}}>
                    <a onClick={(e)=>{
                      this.createAjaxRequest('access')
                    }} href='#' className='balanceBlock_btn'> Оплатить </a>
                </div> 
        {/* 
        <select >
          <option>1 месяц</option>
          <option>3 месяца</option>
          <option>6 месяцев</option>
          <option>12 месяцев</option>
        </select>
        */}
        </div>
    </div>

            <div className='balancePage_balanceBlock__exapanded balancePage_balanceBlock balancePage_balanceBlockSecond'>
               <div className='balancePage_balanceBlock_label'><BlueWalletIcon /> Баланс </div>
               
               <div className="balancePage_balanceBlock_info" style={{marginTop: '1.8em'}}>
               Деньги с баланса начнут списываться после того, как у вас закончатся
               подписчики и сообщения, предусмотренные тарифом.
               </div>
               
               <div className='balancePage_balanceBlock_numBerBalance balancePage_balanceBlock_num' 
               style={{marginTop: '3em'}}>
                    <BlueCircleIcon /> {this.state.dop_balance} руб.
                </div> 
                <input value={this.state.amount} onChange={this.changeDopBalance} placeholder='Сумма ' type='number' className='balanceInput'/> руб.
                <div style={{'marginTop': '3em', 'color': '#9197B3'}}>
                  Введите email для получения чека: 
                  <input  value={this.state.email} onChange={this.handleChangeEmail} style={{ 'color' : '#8D8D8D','paddingLeft': '1em', 'marginTop': '0.3em', 'height': '2.3em'}} type='text' />

                </div>
                <div className='balancePage_balanceBlock_btnBlock'  style={{marginTop: '3.5em'}}>
                    <a onClick={(e)=>{
                      this.createAjaxRequest('dopBalance')
                    }} href='#'  className='balanceBlock_btn'> Пополнить </a>
                </div> 
            </div>      
          </div>
    </div>
    

    

                              
            </div>
        )
    }
}